/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Products_Export_PrefixInputs */

const en_inventory_products_export_prefix = /** @type {(inputs: Inventory_Products_Export_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inventory-products`)
};

const es_inventory_products_export_prefix = /** @type {(inputs: Inventory_Products_Export_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`productos-inventario`)
};

/**
* | output |
* | --- |
* | "inventory-products" |
*
* @param {Inventory_Products_Export_PrefixInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_products_export_prefix = /** @type {((inputs?: Inventory_Products_Export_PrefixInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Products_Export_PrefixInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_products_export_prefix(inputs)
	return es_inventory_products_export_prefix(inputs)
});